<template>
  <div class="item-selector-container">
    <div class="item-selector-header d-flex justify-content-between px-3">
      <span class="name">{{ groupName }}</span>
      <div class="text-right">
        <sc-button
          variant="danger"
          v-if="!isAffectApp && !deletedAt"
          @click="handleCancelGroup"
          >ยกเลิกกรุ๊ป</sc-button
        >
        <sc-button
          variant="primary"
          v-if="!deletedAt"
          @click="handleClickSave"
          >บันทึก</sc-button
        >
      </div>
    </div>
    <div class="item-selector" :class="classList">
      <searchable-item-list
        v-if="showSearchList"
        class="search-list"
        :query="query"
        @queryChange="handleQueryChange"
        :isLoading="isLoading"
        :value="selectableItems"
        @select="handleSelectItem"
      ></searchable-item-list>
      <selected-item-list
        :disabled="disabled"
        :deletedAt="deletedAt"
        class="selected-list"
        :value="value"
        @remove="handleRemoveItem"
        @removeAll="handleRemoveAllItem"
      ></selected-item-list>
    </div>
  </div>
</template>

<script>
import differenceWith from "ramda/src/differenceWith";
import { Input } from "element-ui";
import ItemSelectorOption from "./ItemSelectorOption";
import SelectedItemList from "./SelectedItemList";
import SearchableItemList from "./SearchableItemList";
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";
import { debounce } from "@/lib/util";
import { isNil } from "ramda";

export default {
  components: {
    ItemSelectorOption,
    "el-input": Input,
    SelectedItemList,
    SearchableItemList,
    ScButton
  },
  props: [
    "allItem",
    "groupName",
    "value",
    "disabled",
    "isAffectApp",
    "deletedAt"
  ],
  data() {
    return {
      query: "",
      isLoading: false
    };
  },
  computed: {
    selectableItems() {
      const allItem = this.allItem ? this.allItem : [];

      return differenceWith(this.compareItem, allItem, this.value);
    },
    disabledRemoveButton() {
      return this.value.length === 0;
    },
    showSearchList() {
      return !this.disabled && !this.deletedAt;
    },
    classList() {
      return { disabled: this.disabled };
    }
  },
  watch: {
    query(oldVal, newVal) {
      this.watchQuery();
    }
  },
  methods: {
    handleSelectItem(itemId) {
      this.$emit("selectedItem", itemId);
    },
    handleRemoveItem(itemId) {
      this.$emit("removedItem", itemId);
    },
    handleRemoveAllItem() {
      if (!confirm("คุณต้องการลบทุกรายการใช่หรือไม่")) {
        return;
      }

      this.$emit("removedAllItem");
    },
    compareItem(item, item2) {
      return item.id === item2.id;
    },
    handleQueryChange(value) {
      this.query = value;
    },
    handleClickSave() {
      this.$emit("updateGroup");
    },
    handleCancelGroup() {
      this.$emit("cancelGroup");
    },
    watchQuery: debounce(function () {
      this.$emit("searchItem", this.query);
    }, 1.5)
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.item-selector-container {
  background: white;
  padding: 0;
  max-height: 100%;
}

.item-selector-header {
  border-bottom: 1px solid #e0e0e0;
  padding: 13px;
}

.name {
  font-size: 23px;
  font-weight: bold;
}

.item-selector {
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: calc(100% - 65px);

  > .search-list {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  > .selected-list {
    border-left-width: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

.item-selector.disabled {
  display: block;

  > .selected-list {
    border-left-width: 1px;
    border-radius: $border-radius;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/group/components/ItemSelector/ItemSelector.vue